// extracted by mini-css-extract-plugin
export default {"rating":"xH-z","numberOfStars":"yH-z","count":"zH-z","barGraphSpacing":"AH-z","barGraph":"BH-z"};